import React from 'react';
import { useSetCurrentWebStationId } from 'client/hooks/user/useSetCurrentWebStationId';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { usePermissionsCtx } from 'client/contexts/Permissions';
import { useOptimizelyFeature } from 'client/hooks/useOptimizelyFeature';

// This component is for testing purposes
// and should be removed in favor of the
// Station Switcher UI once it is built
// To be completed in MS-1700
const TempMUMSSwitcher = () => {
  const { setCurrentWebStationId } = useSetCurrentWebStationId();
  const { fetchCurrentUser } = useCurrentUserCtx();
  const { authorizedShows } = usePermissionsCtx();
  const [MUMS_FEATURE_FLAG] = useOptimizelyFeature('mums');

  if (!MUMS_FEATURE_FLAG) return null;

  return (
    <div>
      <p style={{ color: 'white' }}>MUMS Show Switcher</p>
      {authorizedShows?.map(show => (
        <button
          onClick={() => {
            setCurrentWebStationId(show.webStationId, {
              onSuccess: () => {
                fetchCurrentUser();
              },
            });
          }}
        >
          {show.webStationId}
        </button>
      ))}
    </div>
  );
};

export { TempMUMSSwitcher };
